import { ReactComponent as CloseIcon } from "@/Images/icons/Close.svg"
import { clsx } from "clsx"
import { PropsWithChildren, ReactNode, useEffect, useRef } from "react"
import { createPortal } from "react-dom"
import "./style.sass"

interface ModalProps extends PropsWithChildren {
  show: boolean
  onClose: VoidFunction
  title?: ReactNode
  closeable?: boolean
  className?: string
}
export const Modal = ({ className, title, closeable = true, show, onClose, children }: ModalProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const wrapper = wrapperRef.current
    const content = contentRef.current
    if (wrapper == null || content == null) return
    setTimeout(() => {
      wrapper.classList.add("custom-modal-show")
      content.classList.add("custom-modal__content-show")
    }, 20)
  }, [show])

  if (!show) return null
  return createPortal(
    <div ref={wrapperRef} className="custom-modal" onClick={onClose}>
      <div ref={contentRef} className={clsx("custom-modal__content mx-2", className)} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start md:items-center justify-between text-[18px] text-black font-bold gap-6">
          {title}
          {closeable && (
            <div className="hover:bg-gray-100 p-2 cursor-pointer rounded-lg" onClick={onClose}>
              <CloseIcon />
            </div>
          )}
        </div>

        {children}
      </div>
    </div>,
    document.getElementById("root")!,
  )
}
